import * as React from "react";
import {IBackOfficeTheme} from "../theme";
import {defaultTheme} from "../default/index";

import {fullWhite, fullBlack} from 'material-ui/styles/colors';
import {SportappLogo} from "./components/SportappLogo";
import {SportappShortLogo} from "./components/SportappShortLogo";
import {SportappNonLoggedBG} from "./components/NonLoggedBG/SportappNonLoggedBG";
import {BasicPhone} from "../components/BasicPhone";

const primaryColor = '#D9DCDE';
const accentColor = '#E6171D';
const accent2Color = '#000';
const backgroundColor = '#D9DCDE';
const activeBackgroundColor = '#3389FF';
const alternateTextColor = '#3389FF';
const labelColor = fullBlack;
const hintColor = fullBlack;
const raisedButtonPrimaryColor = '#3389FF';
const raisedButtonSecondaryColor = "#81b4e3";

export const sportappTheme: IBackOfficeTheme = {
  ...defaultTheme,
  primaryColor: primaryColor,
  accentColor: accentColor,
  accent2Color: accent2Color,
  backgroundColor: backgroundColor,
  alternateTextColor: alternateTextColor,
  labelColor: labelColor,
  hintColor: hintColor,
  raisedButtonPrimaryColor: raisedButtonPrimaryColor,
  raisedButtonSecondaryColor: raisedButtonSecondaryColor,
  logo: {
    component: SportappLogo,
    style: {
      width: 314,
      height: 59
    }
  },
  nonLogged: {
    bgComponent: SportappNonLoggedBG,
    phoneComponent: React.createElement(BasicPhone),
    phoneScreenUrl: <string>require('./assets/menu.png')
  },
  navBar: {
    logo: SportappShortLogo,
    backgroundColor: primaryColor,
    activeBackgroundColor: activeBackgroundColor,
    color: fullBlack,
    iconColor: accentColor
  }
};



// WEBPACK FOOTER //
// ./src/themes/sportapp/index.ts